<template>
  <Container type="card-full" drankColor>
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable ></el-input>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">平台编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectno" clearable ></el-input>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="true" :resizable="true" :defaultPage="10"
            :total="query.total" @cellClick="cellClick"  @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  /* eslint-disable */
  export default {
    name: 'psuBzjReturnIndex',
    data () {
      return {
        menuid:  this.$route.query.menuid || this.$route.params.menuid,
        list: [],
        btnLoading: false,
        btn:{},
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 50 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false, width: 140},
          // { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false, width: 140},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          { field: 'prsflgdesc', fieldtype: 'C', title: '交易方式',calculExpr:'',addNewRowFlg: false, width: 80},
          { field: 'projectdoneflgdesc', fieldtype: 'C', title: '评审方法',calculExpr:'',addNewRowFlg: false, width: 120},
          { field: 'pcomfullname', fieldtype: 'C', title: '采购人',calculExpr:'',addNewRowFlg: false},
          // { field: 'acomfullname', fieldtype: 'C', title: '代理人',calculExpr:'',addNewRowFlg: false},
          { field: 'cusername', fieldtype: 'C', title: '建项人',calculExpr:'',addNewRowFlg: false, width: 80},
          // { field: 'cusermobile', fieldtype: 'C', title: '建项人手机',calculExpr:'',addNewRowFlg: false, width: 110},
          { field: 'psuusername', fieldtype: 'C', title: '报名人',calculExpr:'',addNewRowFlg: false, width: 80},
          { field: 'psufeepayurlCN', fieldtype: 'C', title: '状态',calculExpr:'',addNewRowFlg: false, width: 70},
          {
            title: '通知书 ', width: 125, showOverflow: true,align: "center",
            slots: {
              default: 'default',
              default: ({row}) => {
                if(row.psubidflg === 1){
                  return [<vxe-button type='primary' onClick={this.toSeeCJTZX.bind(this, row)}>领取</vxe-button>]
                }
              }
            }
          },
          {
            title: '操作 ', width: 125, showOverflow: true,
            slots: {
              default: 'default',
              default: ({row}) => {
                if(row.psuconfirmfeeamt > 0 && +row.psufewreceive === 2){
                  return [<vxe-button type='primary' onClick={this.chgServicefee.bind(this, row)}>重新缴纳服务费</vxe-button>]
                } 
                else if(row.psuconfirmfeeamt > 0 && +row.psufeepayflg === 0){
                  return [<vxe-button type='primary' onClick={this.chgServicefee.bind(this, row)}>缴纳服务费</vxe-button>]
                }
                else if (row.psuconfirmfeeamt > 0 && +row.psufeepayflg === 1 && !row.psufwfinvoice) {
                  return [<vxe-button type='primary' onClick={this.chgServicefee.bind(this, row)}>申请发票</vxe-button>]
                }
                else if(!row.appendurl){
                  return [<vxe-button type='primary' onClick={this.chgServicefee.bind(this, row)}>上传合同</vxe-button>]
                }
                else {
                  return [<vxe-button type='primary' onClick={this.chgServicefee.bind(this, row)}>查看</vxe-button>]
                }
              }
            }
          }
        ],
        psu: {},
        query: {
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 10,
          offset: 0
        },
        projectStatusList:[],
      }
    },
    created () {
      this.$on('JNFWF', () => this.chgServicefee())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getPageList()
      this.getProjectStatusList()
    },
    mounted () {
      this.init()
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.project = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.query = {
          comid: this.$store.getters.loginUser.comid,
          limit: 10,
          offset: 0}
        this.list = []
        this.btnLoading = false
        this.psu = {}
      },
      async getProjectStatusList () {
        this.projectStatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'psubzjreturnflg'}
        })
      },
      async viewProject(row) {
        //不可以交服务费后才能看
        // if(+row.row.psufeepaytype === 0 && row.row.psuconfirmfeeamt>0){
        //   this.$message.warning('请先缴纳服务费')
        //   return
        // }
        // else{
        //   this.$router.push({name: 'projectBiddingNotice', params: {projectid:row.row.projectid,psuid: row.row.psuid}})
        // }
        // this.$router.push({name: 'pjBiddingNotice', params: {projectid:row.row.projectid,psuid: row.row.psuid}})
                  
        // let {href} = this.$router.resolve({name: 'pjBiddingNotice', query: {psuid: row.row.psuid,projectid: row.row.projectid}})
        // window.open(href, '_blank')
        this.$router.push({name: 'psuServicepayForm', params: {form: row.row, type: 1}})
      },

      async chgServicefee (row) {
        // if (!this.psu.psuid) {
        //   this.$message.warning('请选择一个项目!')
        //   return
        // }
        if(!row.psuconfirmfeeuserid){
            this.$message.warning('服务费未确认！')
            return
        }
        this.$router.push({name: 'psuServicepayForm', params: {form: row, type: 1}})
        console.log(row, '-')
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async cellClick (row) {
        this.psu = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async toSeeCJTZX(row){
        if(+row.psubcnflg === 1){
          this.$message.warning('通知书暂未制作完成，请耐心等候。')
          return
        }
        let {href} = this.$router.resolve({name: 'pjBiddingNotice', query: {psuid: row.psuid,projectid: row.projectid}})
        window.open(href, '_blank')

      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        this.query.cosid = this.$store.getters.loginUser.cosid
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getServicefee',
          params: this.query
        })
        res.list.forEach((key)=>{
          key.psufeepayurlCN = "未支付"
          if(+key.psufeepaytype > 0 && +key.psufewreceive !== 2){
            key.psufeepayurlCN = "待确认"
          }
          if(+key.psufewreceive === 1)
            key.psufeepayurlCN = "已支付"
          // key.psuconfirmfeeamtCN = key.psuconfirmfeeamt?utils.comdify(key.psuconfirmfeeamt):"未确认"
          key.time = key.psufeechecktime?key.psufeechecktime:key.psufeepaytime
          key.name = key.psufeepayusername?key.psufeepayusername:key.payfeecheckusername
          // key.psufeeamt = utils.comdify(key.psufeeamt)
        })
        // res.list = res.list.filter(v => v.psuconfirmfeeuserid)
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
